<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="closePopup">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div class="flex-cont">
                <div class="date inl">
                    {{ qDate }}
                </div>
                <div class="inl">
                        <el-radio-button 
                            v-for="(option, index) in [...questionOptions, ...prevOtherOptions]"
                            @click.native.prevent="clickItem(option.label,index)"
                            :key="'pre' + index"
                            :label="option.label"
                            :class="[{ selected: updateResponse != null && !!updateResponse.length && updateResponse.includes(option.label) }]">
                        </el-radio-button>
                        <div 
                            class="inl other-added-option-container"
                            v-if="otherEnabled && otherOptionList && otherOptionList.length > 0">
                            <span
                                :class="['other-added-option',{ 'otherSelectedOption': updateResponse != null && !!updateResponse.length && updateResponse.includes(option) }]" 
                                v-for="(option, index) in otherOptionList"
                                @click.self="clickItem(option,index)"
                                :key="'pre' + index">
                                    {{ option }}
                            </span>
                        </div>
                        <el-button
                            class="inl add-button-container"
                            v-if="otherEnabled && !showAddInput"
                            @click="addInputIconClicked()">
                                <AddIcon class="add-button"></AddIcon>
                        </el-button>
                        <span v-if="updateResponse && updateResponse.length < 1" class="no-answer">
                            Not Answered
                        </span>
                        <div class="other-input-container">
                            <el-input 
                                class="other-input-field"
                                v-if="otherEnabled && showAddInput"
                                v-model="otherOption"
                                placeholder="Add other option" 
                                @change="addOtherInput()">
                            </el-input>
                        </div>
                </div>
            </div>
            <div class="footer">
                <div class="remove-response" v-if="showRmvResp">
                    <RemoveResponseIcon></RemoveResponseIcon>
                    <span @click="removeResponse()">Remove Response</span>
                </div>
                <div class="mandatory-quest" v-if="checkIfMandatory()"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!enableSave"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from '.'
import Icons from '../analysis/response/icon'
import { v4 as uuidv4 } from 'uuid'

const starOptions = Array.from(Array(5)).map((_, index) => ({
    label: (index + 1) + ' star',
    value:  String(index)
}))

export default {
    name: 'edit-select-bubble',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: [],
            prevOtherOptions: [],
            questionOptions: this.getQuestionOptions(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
            otherEnabled: this.checkIfOtherEnabled(),
            singleSelect: this.checkIfSingleSelectable(),
            showAddInput: false,
            otherOption: "",
            otherOptionList: [],
        }
    },

    created() {
        this.getQuestionResponse()
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = []
            this.prevOtherOptions = []
            this.showRmvResp = !this.checkIfMandatory() && this.response
            this.otherEnabled = this.checkIfOtherEnabled(),
            this.singleSelect = this.checkIfSingleSelectable(),
            this.showAddInput = false,
            this.otherOption = "",
            this.otherOptionList = [],
            this.questionOptions = this.getQuestionOptions(),
            this.getQuestionResponse()
        },
        clickItem(e,indx) {
            if(this.updateResponse && !this.updateResponse.length) {
                this.updateResponse.push(e)
            } else {
                if(this.singleSelect) {
                    if(this.updateResponse.includes(e)) {
                        if(!this.checkIfMandatory()) {
                            this.updateResponse = []
                        }
                    } else {
                        this.updateResponse = []
                        this.updateResponse.push(e)
                    }
                }
                else {
                    if(this.updateResponse.includes(e)) {
                        if(!this.checkIfMandatory() || this.updateResponse.length > 1) {
                            const foundIndex = this.updateResponse.indexOf(e)
                            if (foundIndex > -1) {
                                this.updateResponse.splice(foundIndex, 1)
                            }
                        }
                    } else {
                        this.updateResponse.push(e)
                    }
                }
            }

            this.onResponseChange()
        },
        checkIfOtherEnabled() {
            if(this.question.other)
                return true
            else
                return false
        },
        checkIfSingleSelectable() {
            if(this.question.single)
                return true
            else
                return false
        },
        removeResponse() {
            this.updateResponse = []
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onResponseChange() {
            if(this.updateResponse.length > 0) {
                this.enableSave = true
                this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
                this.showRmvResp = false
            }
        },
        addInputIconClicked() {
            this.showAddInput = true
        },
        addOtherInput() {
            if(this.otherOption && this.otherOption.trim() !== "") {
                if(this.singleSelect) {
                    this.updateResponse = []
                }
                this.otherOptionList.push(this.otherOption)
                this.updateResponse.push(this.otherOption)
                this.otherOption = ""
            }
            this.enableSave = true
            this.showAddInput = false
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false,
                    this.showEdit = false,
                    this.enableSave = false,
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                    this.otherEnabled = this.checkIfOtherEnabled(),
                    this.singleSelect = this.checkIfSingleSelectable(),
                    this.showAddInput = false,
                    this.otherOption = "",
                    this.updateResponse = []
                    this.prevOtherOptions = []
                    this.otherOptionList = []
                    this.getQuestionResponse()
                })
        },
        getQuestionOptions() {
            switch (this.question.type) {
                case 'box_select':
                    return this.question.options.map((elem) => ({
                        value: elem.value,
                        label: elem.value
                    }))
                case 'large_image_select':
                    return Object.entries(this.question.select).map(([value, label]) => ({
                        value: label,
                        label
                    }))
                case 'small_image_select':
                    return Object.entries(this.question.select).map(([value, label]) => ({
                        value: label,
                        label
                    }))
                case 'select':
                    return this.question.option.map((value) => ({
                        value,
                        label: value
                    }))
                case 'long_text_bubble':
                    return this.question.options.map(({display_text, value}) => ({
                        value,
                        label: display_text
                    }))
                default:
                    return []
            }
        },
        getQuestionResponse() {
            if(!this.oresponse)
                return []
            switch (this.question.type) {
                case 'box_select':
                    return this.getRespFromOresp()
                case 'large_image_select':
                    return this.getRespFromOresp()
                case 'small_image_select':
                    return this.getRespFromOresp()
                case 'select':
                    return this.getRespFromOresp()
                case 'long_text_bubble':
                    return this.getRespFromOresp()
                default:
                    return []
            }
        },
        getRespFromOresp() {
            let tempAnswers = [], tempQuestOptions = [], tempPrevOtherOptions = [], tempNormalOptionAnswer = []

            if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0) {
                tempAnswers = this.oresponse.map((element) => {
                    if(typeof element === 'object') {
                        return element.value
                    } else {
                        return element
                    }
                })
            } else if(this.oresponse && typeof this.oresponse === 'object') {
                tempAnswers = Object.values(this.oresponse)
            } else {
                tempAnswers = this.oresponse
            }

            tempQuestOptions = this.question.options.map((option) => option.value)

            if(tempAnswers && !!tempAnswers.length) {
                tempAnswers.forEach((answer) => {
                    if(!tempQuestOptions.includes(answer)){
                        tempPrevOtherOptions.push({
                            value: answer,
                            label: answer
                        })
                    }
                    tempNormalOptionAnswer.push(answer)
                })
            }
            this.prevOtherOptions = [...tempPrevOtherOptions]
            this.updateResponse = [...tempNormalOptionAnswer]
        },
        getOptionAddedObject(optVal) {
            let tempVar, optionObject

            optionObject = this.oresponse && this.oresponse.find(({value}) => optVal == value)

            if(optionObject != undefined || optionObject != null) {
                tempVar = JSON.parse(JSON.stringify(this.oresponse.find(({value}) => optVal == value)))
            } else {
                tempVar = JSON.parse(JSON.stringify(this.question.options.find(({value}) => value == optVal)))
            }

            return tempVar
        },
        createOtherOptionAddedObject(otherValue) {
            return {
                description: otherValue,
                value: otherValue,
                id: uuidv4()
            }
        },
        getSelectedOptionObject(selectedValues) {
            if(selectedValues.length > 0) {
                return selectedValues.map((selVal) => {
                    if(this.otherOptionList && this.otherOptionList.includes(selVal)) {
                        return this.createOtherOptionAddedObject(selVal)
                    }
                    else {
                        return this.getOptionAddedObject(selVal)
                    }
                })
            } else return []
        },
        getImageOptionObject(selectedValue) {
            const tempObj = JSON.parse(JSON.stringify(this.question.options.find(({value}) => value == selectedValue)))
            return (({ id, value }) => ({ id, value }))(tempObj)
        },
        getSelectedImageOptionObject(selectedValues) {
            if(selectedValues.length > 0) {
                return selectedValues.map((selVal) => {
                    if(this.otherOptionList && this.otherOptionList.includes(selVal)) {
                        return this.createOtherOptionAddedObject(selVal)
                    }
                    else {
                        return this.getOptionAddedObject(selVal)
                    }
                })
            } else return []
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            switch (this.question.type) {
                case 'box_select':
                    update.answer = this.getSelectedOptionObject(this.updateResponse)
                    break
                case 'select':
                    update.answer = this.getSelectedOptionObject(this.updateResponse)
                    break
                case 'long_text_bubble':
                    update.answer = this.getSelectedImageOptionObject(this.updateResponse)
                    break
                case 'large_image_select':
                    update.answer = this.getSelectedImageOptionObject(this.updateResponse)
                    break
                case 'small_image_select':
                    update.answer = this.getSelectedImageOptionObject(this.updateResponse)
                    break
            }
            return update
        },
    },

    computed: {
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
label.el-radio-button {
    margin: 5px;

    ::v-deep span.el-radio-button__inner {
        border-radius: 25px;
        background-color: #F8F8F8;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        color: #666666;
        font-size: 12px;
        box-shadow: none;
        white-space: break-spaces;
        text-align: left;
        word-break: break-word;
    }

    &.selected{
        ::v-deep .el-radio-button__inner {
            border-radius: 25px;
            background-color: #EDF8DF;
            border: 1px solid #709F34;
            box-sizing: border-box;
            color: #709F34;
            font-size: 12px;
            box-shadow: none;
            white-space: break-spaces;
            text-align: left;
            word-break: break-word;
        }
    }

    &:focus:not(.is-focus):not(:active):not(.is-disabled) {
        box-shadow: none;
    }
}

.add-button-container {
    border: none;
    padding: 0px;

    &:hover {
        box-shadow: none;
        background-color: transparent;
    }

    ::v-deep svg {
        height: 30px;
        width: 30px;
        position: relative;
        top: 10px;
    }
}

.other-added-option-container {
    margin: 0px 5px;

    .other-added-option {
        margin: 5px;
        padding: 12px 20px;
        border-radius: 25px;
        background-color: #F8F8F8;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        color: #666666;
        font-size: 12px;
        box-shadow: none;
        display: inline-block;
    }

    .otherSelectedOption {
        background-color: #EDF8DF;
        border: 1px solid #709F34;
        color: #709F34;
    }
}

.other-input-container {
    position: relative;
    top: 15px;

    .other-input-field {
        ::v-deep input.el-input__inner {
            border-radius: 25px;
            font-size: 12px;
            background-color: #F8F8F8;
        }
    }
}
</style>
